<template>
    <div class="detail-shell">
        <div class="container"  v-loading="loading">
          <div class="title1">中国资产评估协会</div>
          <div class="title2">资产评估业务报告备案回执</div>
          <el-descriptions
              :labelStyle="{width:'150px',textAlign:'right',fontSize:'16px',color:'#565656',fontWeight:'bold'}"
              :contentStyle="{textAlign:'left',fontSize:'16px'}"
              class="report-descriptions" :column="1" border>

            <el-descriptions-item>
              <template slot="label">
                报告编码:
              </template>
              {{ data.creditCode }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                合同编号:
              </template>
              {{ data.contractNum }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                报告类型:
              </template>
              {{ data.pgcategoryTitle }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                报告文号:
              </template>
              {{ data.libraryNum }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                报告名称:
              </template>
              {{ data.title }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                评估结论:
              </template>
              {{ data.parentCompanyOwnershipBookAssessmentValue }}元
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                评估机构名称:
              </template>
              {{ data.companyTitle }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                签名人员:
              </template>
<!--              {{ data.pgsignperson }}-->
              <el-row>
                <el-col :key="index" v-for="(item,index) in data.pgsignperson" :span="24">
                  <span style="min-width:50px;display: inline-block">{{item.name}}</span>{{item.type}} 会员编号：{{item.vipNum}}</el-col>
              </el-row>
            </el-descriptions-item>
<!--            <el-descriptions-item>-->
<!--              <template slot="label">-->
<!--                二维码:-->
<!--              </template>-->
<!--              <div style="display: flex;flex-direction: column;justify-content: center;align-items: center">-->
<!--                <el-image-->
<!--                    style="width: 100px; height: 100px"-->
<!--                    :src="url"-->
<!--                    :preview-src-list="srcList">-->
<!--                </el-image>-->
<!--                <div style="color: #999">(可扫描二维码查询备案业务信息)</div>-->
<!--              </div>-->

<!--            </el-descriptions-item>-->


          </el-descriptions>
          <br>
          <div class="description-note">
            说明：报告备案回执仅证明此报告已在业务报备管理系统进行了备案，不作为协会对该报告认证、认可的依据，也不作为资产评估机构及其签字资产评估专业人员免除相关法律责任的依据。
          </div>

          <br>
          <div class="create-date">生成日期：{{data.createDateTime}}</div>
          <br>
        </div>

    </div>

</template>

<script>
// @ is an alias to /src

export default {
  name: 'PgDetail',
  components: {

  },
  mounted(){
    // window.onresize =  ()=> {
    //   this.style.width = '100%'
    //   this.style.height = '100%'
    // }
  },
  data(){
    return{
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      ],
      loading:false,
    }
  },
  computed:{
    data(){
      return this.$store.getters.getLibraryInfo
    }
  },
  methods:{

  }
}
</script>
<style lang="scss" scoped>
    .detail-shell{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        background-color: #f6f6f6;
    }
    .container{
        width:90%;
        height: 85%;
        background-color: #fff;
        overflow-y: auto;
        overflow-x:hidden;
        border-top: 18px solid #1366E3;

      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      .title1{
        margin-top: 20px;
        font-size: 28px;
        text-align: center;
        font-family: '方正小标宋简体'
      }
      .title2{
        margin: 20px 0;
        font-size: 21px;
        font-family: '方正小标宋简体';
      }
        .item-box{
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            margin-bottom: 15% ;
            width: 100%;
        }
        .label{
            color: #999;
            font-size: 20px;
            margin-bottom: 15px;
        }
        .value{
            width: 100%;
            color: #333;
            font-size:20px;
        }
    }
    .report-descriptions,
    .description-note,
    .create-date { width: min(800px, calc(100% - 48px)); }
    .description-note { margin-top: 3px; line-height: 25px; font-size: 14px; background-color: #fff; }
    .create-date { text-align: right; }
</style>
